import { ES_SEARCH_ITEMS } from '@doda/common/src/constants/searchItems';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { EstablishListType } from 'types/kodawari';
import { HooksArgument } from 'components/SearchSideBar/types';
import { getInitialIdList } from '../getInitialIdList';

/**
 * 設立年数の初期状態を生成
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.jobCountData 求人件数
 * @param param.queries クエリパラメータ
 * @returns 設立年数の初期配列
 */
export const createInitialEstablishList = ({
  savedSearchCondition,
  featuredSearchCondition,
  jobCountData,
  queries,
}: HooksArgument) => {
  const paramList = getInitialIdList({
    savedSearchCondition,
    featuredSearchCondition,
    queries,
  });

  const initialData: EstablishListType[] = ES_SEARCH_ITEMS.map((item) => ({
    id: item.id,
    name: item.name,
    isChecked: paramList.some((query) => query === item.id),
    value: item.id as EstablishListType['value'],
    jobCount: findJobCount(jobCountData.establishList, item.id),
  }));

  return initialData;
};
